import { Preferences as Storage } from "@capacitor/preferences";

export default Storage;
